import { Carousel } from "./Carousel";
import { XBloomProvider } from "./xbloom/useXBloom";


export const App: React.FC = () => {
  return (
    <XBloomProvider>
      <Carousel />
    </XBloomProvider>
  );
};
